import { CloseOutlined } from '@ant-design/icons';

import { Flex } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import { useModalContext } from '@/components/Modal/Modal';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import useKeymap from '@/hooks/pure/useKeymap';
import UploadStyles from '@/layouts/UploadLayout';
import { GlobalModalWrapper } from '@/styles/style';

import CompanyUploadBody from './CompanyUploadBody';

const CompanyUploadModal = () => {
  const color = useColor();

  const { closeModal } = useModalContext();
  useKeymap('Escape', closeModal);

  return (
    <GlobalModalWrapper onClick={(e) => e.stopPropagation()}>
      <UploadStyles.UploadLayout>
        <UploadStyles.HeaderArea>
          <Flex
            a="center"
            style={{ padding: '0 32px', height: '100%' }}
            j="space-between"
          >
            <Typo type="body2" weight="sb" color={color.gray800}>
              Upload CSV / Excel
            </Typo>
            <IconButton
              icon={<CloseOutlined />}
              onClick={closeModal}
              tooltip="Close"
              shortcut="ESC"
            />
          </Flex>
        </UploadStyles.HeaderArea>
        <UploadStyles.BodyArea>
          <CompanyUploadBody closeUploadModal={closeModal} />
        </UploadStyles.BodyArea>
      </UploadStyles.UploadLayout>
    </GlobalModalWrapper>
  );
};

export default CompanyUploadModal;
